import React, { Component, Fragment } from 'react';
import _ from 'lodash';

import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Select,
} from 'antd';

import { ErrorsList } from '../../ErrorsList';
import { isAbn, isPostcode } from '../../../utils';
import { asyncValidator, connectForm } from '../../form';
import { ButtonBar } from '../../elements';
import { maybeFormatPhone, phoneNumberValidator } from '../../fields/PhoneNumberField';

const australianStates = [
  { abbr: 'ACT', name: 'Australian Capital Territory' },
  { abbr: 'NSW', name: 'New South Wales' },
  { abbr: 'NT', name: 'Northern Territory' },
  { abbr: 'QLD', name: 'Queensland' },
  { abbr: 'SA', name: 'South Australia' },
  { abbr: 'Tas', name: 'Tasmania' },
  { abbr: 'Vic', name: 'Victoria' },
  { abbr: 'WA', name: 'Western Australia' },
];

const abnValidator = asyncValidator(
  (rule, value) => ((value && !isAbn(value))
    ? ['Invalid ABN']
    : []),
);

const postcodeValidator = asyncValidator(
  (rule, value) => (
    (value && !isPostcode(value))
      ? ['Invalid Postcode']
      : []
  ),
);

const forceString = val => (val ? String(val) : null);


@connectForm(() => ({}))
class BusinessInfoForm extends Component {
  render() {
    const {
      form, saveInProgress, info, cancelable = true, editMode = true,
    } = this.props;
    const { getConnectedFieldDecorator } = form;
    const Wrapper = editMode ? Form : Fragment;
    return (
      <Wrapper {...(editMode && { onSubmit: this.props.handleSubmit })}>
        <ErrorsList errors={this.props.globalErrors}/>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col sm={24} md={12}>
            <Form.Item label="Name" style={{ backgroundColor: '' }} >
              { getConnectedFieldDecorator('info.name', {
                initialValue: info.name,
                rules: [{
                  required: true,
                  message: 'Name is required',
                }],
              })(
                <Input
                  placeholder="Your name or organisation name"
                />,
              )}
            </Form.Item>
          </Col>


          <Col sm={24} md={12}>
            <Form.Item label="ABN">
              { getConnectedFieldDecorator('info.abn', {
                initialValue: forceString(info.abn),
                rules: [{
                  required: false,
                }],
                validate: [{
                  trigger: 'onBlur',
                  rules: [{ validator: abnValidator }],
                }],
              })(
                <Input placeholder="00 000 000 000" />,
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col sm={24} md={12}>
            <Form.Item label="Billing Email">
              { getConnectedFieldDecorator('info.email', {
                initialValue: info.email,
                validate: [{
                  trigger: 'onBlur',
                  rules: [{
                    required: true,
                    message: 'Billing Email is required',
                  }, {
                    type: 'email',
                    message: 'Email address is invalid',
                  }],
                }],
              })(
                <Input placeholder="Email address for billing contact person"/>,
              )}
            </Form.Item>
          </Col>
          <Col sm={24} md={12}>
            <Form.Item label="Organisation Phone">
              { getConnectedFieldDecorator('info.phone', {
                initialValue: maybeFormatPhone(info.phone),
                getValueFromEvent: (({ target: { value } }) => maybeFormatPhone(value)),
                validate: [{
                  trigger: 'onBlur',
                  rules: [{
                    required: true,
                    message: 'Organisation Phone is required',
                  }],
                }, {
                  trigger: 'onBlur',
                  rules: [{
                    validator: phoneNumberValidator,
                    message: 'Invalid phone number',
                  }],
                }],
              })(
                <Input type="tel" placeholder="Organisation Phone Number for billing"/>,
              )}
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col sm={24} md={12}>
            <Form.Item label="Business Address"
              style={{ marginBottom: 0 }}
            >
              { getConnectedFieldDecorator('info.address.street', {
                initialValue: _.get(info, 'address.street', ''),
              })(
                <Input
                  placeholder="Physical Address"
                />,
              )}
            </Form.Item>
            <Form.Item>
              { getConnectedFieldDecorator('info.address.street2', {
                initialValue: _.get(info, 'address.street2', ''),
              })(
                <Input placeholder="Physical Address 2"/>,
              )}
            </Form.Item>
          </Col>
          <Col sm={24} md={12}>
            <Form.Item label="Suburb">
              { getConnectedFieldDecorator('info.address.suburb', {
                initialValue: _.get(info, 'address.suburb', ''),
              })(
                <Input placeholder="Suburb"/>,
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col m={24} md={12}>
            <Form.Item label="Postcode">
              { getConnectedFieldDecorator('info.address.postcode', {
                initialValue: String(_.get(info, 'address.postcode', '')),
                rules: [{
                  validator: postcodeValidator,
                }],
              })(
                <Input placeholder="Postcode"/>,
              )}
            </Form.Item>
          </Col>
          <Col m={24} md={12}>
            <Form.Item label="State">
              { getConnectedFieldDecorator('info.address.state', {
                initialValue: _.get(info, 'address.state'),
              })(
                <Select>
                  {australianStates.map(({ name, abbr }) => (<Select.Option key={abbr} value={abbr}>
                    {name}
                  </Select.Option>))}
                </Select>,
              )}
            </Form.Item>
          </Col>
        </Row>

        { editMode && <ButtonBar>
          { cancelable && (
            <Button
              disabled={saveInProgress}
              onClick={this.props.onCancel}
            >
              Cancel
            </Button>
          )}
          <Button
            loading={saveInProgress}
            htmlType='submit'
            type='primary'
          >
            {this.props.submitText || 'Save'}
          </Button>
        </ButtonBar>}
      </Wrapper>
    );
  }
}

export {
  BusinessInfoForm,
};
